import React, { lazy } from 'react';
import { CheckCircle2 } from 'lucide-react';
const POINTS = ['Custom measured for your bathroom', 'Frameless, semi-frameless and sliding options', 'Multiple glass textures, designs, finishes and hardware choices', 'Designed for a cleaner, brighter, more open bathroom', 'Professional installation by experienced glass technicians'];
export function ShowerGlass() {
  return <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-269">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-270">
        <div className="order-2 lg:order-1 rounded-2xl aspect-video lg:aspect-square w-full overflow-hidden shadow-card anim-on-scroll" data-id="element-271">
          <img src="https://cdn.magicpatterns.com/uploads/czENASGopBHnRmtXUMPtiN/respic2.webp" alt="Custom frameless glass shower enclosure installed by Kosin's Glass" className="w-full h-full object-cover" loading="lazy" data-id="element-272" />
        </div>
        <div className="order-1 lg:order-2 anim-on-scroll" data-id="element-273">
          <h2 className="text-3xl sm:text-4xl font-bold text-navy-900 tracking-tight mb-6" data-id="element-274">
            Custom Glass Shower Doors & Enclosures
          </h2>
          <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-275">
            Upgrade your bathroom with custom glass shower doors and enclosures
            designed to fit your space. Kosin’s Glass offers frameless,
            semi-frameless, sliding and Euro-style shower glass options with
            quality hardware and professional installation.
          </p>
          <ul className="space-y-4 mb-8" data-id="element-276">
            {POINTS.map((point, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-277">
                <CheckCircle2 className="w-5 h-5 text-brandBlue-600 flex-shrink-0 mt-0.5" aria-hidden="true" data-id="element-278" />
                <span className="text-slate-700 font-medium" data-id="element-279">{point}</span>
              </li>)}
          </ul>
          <a href="/glassshowerdoors.html" className="inline-flex items-center justify-center bg-white border-2 border-brandBlue-600 text-brandBlue-600 hover:bg-brandBlue-50 font-bold text-lg py-3 px-8 rounded-xl transition-colors" data-id="element-280">
            Explore Glass Shower Doors
          </a>
        </div>
      </div>
    </section>;
}